exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menus-listing {\n  overflow-x: auto;\n  overflow-y: hidden;\n  background: white;\n}\n.menus-listing .menu-type {\n  border-radius: 15px;\n  margin-right: 5px;\n  text-transform: capitalize;\n  height: 30px;\n}\n.menus-listing .menu {\n  border-radius: 15px;\n  margin-right: 5px;\n  text-transform: capitalize;\n  height: 30px;\n}\n.menus-listing .menu.active {\n  color: white;\n}\n.menus-listing .menu:not(.active):hover {\n  background-color: #ebebeb;\n}\n.menus-listing .menu:last-child {\n  margin-right: 0px;\n}", ""]);

// exports
